import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import host from "../../assets/js/Host";
import axios from "../../assets/js/AxiosInterceptors";
import { toast } from "react-toastify";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  Divider,
  FormControlLabel,
  Grid,
  Slide,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import CustomeSelectField from "../../Components/CustomeSelectField";
import CustomTextField from "../../Components/CustomTextField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ContainerOfInputFields } from "../../Components/ThemDesign";
import { debounce } from "debounce";
import { subDays, addDays } from "date-fns";
import { setGlobalLoading } from "../../reduxStore/SettingsReducer";
import IconButton from "@mui/material/IconButton";
import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import Preloading from "../Preload/Preloading";
import helpers from "../../assets/js/helper";
import AddIcon from "@mui/icons-material/Add";
import VehiclesList from "./components/VehiclesList";
import swal from "sweetalert";
import { useTheme } from '@mui/material/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  appBar: {
    position: "relative",
    backgroundColor: "#2e6b95",
  },
  title: {
    marginLeft: useTheme().spacing(2),
    flex: 1,
  },
  oddRow: {
    borderRadius: "5px",
    marginTop: useTheme().spacing(1),
    padding: useTheme().spacing(1),

    backgroundColor: "#ffffff",
  },
  evenRow: {
    borderRadius: "5px",
    marginTop: useTheme().spacing(1),
    padding: useTheme().spacing(1),
    backgroundColor: "#ffffff",
  },
  typographyClass: {
    fontFamily: "'Cairo'",
  },
  typographyOddClass: {
    fontFamily: "'Cairo'",
    color: "#2e6b95",
  },
  typographyEvenClass: {
    fontFamily: "'Cairo'",
    color: "#2e6b95",
  },
  containerHeader: {
    backgroundColor: "#fff",
  },
  innerContainerHeader: {
    // paddingTop: useTheme().spacing(2),
    // paddingBottom: useTheme().spacing(1),

    justifyContent: "center",
    backgroundColor: "#fff",
    width: "100%",
    height: "100%",
  },
  firstColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    // padding: "15px",
    textAlign: "center",
    backgroundColor: "#2e6b95",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  secondColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#2e6b95",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  thirdColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    textAlign: "center",
    padding: "15px",
    backgroundColor: "#e7e8e8",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    color: "#2e6b95",
  },
  fourthColumnHeader: {
    borderRadius: "5px 5px 0px 0px",
    backgroundColor: "#e7e8e8",
    textAlign: "center",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    padding: "15px",
    color: "#2e6b95",
  },

  ColumnHeaders: {
    textAlign: "center",
    fontWeight: 600,

    margin: "0 auto",
  },

  container: {
    height: "100%",
    backgroundColor: "#f5f5f5",
    overflow: "hidden",
  },
  innerContainer: {
    // paddingTop: useTheme().spacing(1),
    paddingBottom: useTheme().spacing(1),
    height: "100%",
    justifyContent: "space-around",
    backgroundColor: "#f5f5f5",
  },
  firstColumn: {
    borderRadius: "0px 0px 0px 0px",
    // padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
  },
  secondColumn: {
    borderRadius: "0px 0px 0px 0px",
    // padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px  rgba(0, 0, 0, 0.1)",
  },
  thirdColumn: {
    borderRadius: "0px 0px 5px 5px",
    textAlign: "center",
    padding: "15px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
  },
  fourthColumn: {
    borderRadius: "0px 0px 5px 5px",
    backgroundColor: "#ffffff",
    boxShadow: "3px 3px rgba(0, 0, 0, 0.1)",
    padding: "15px",
  },
}));

const cookies = new Cookies();

const RenderContent = (props) => {
  const classes = useStyles();
  const maintheme = useSelector((state) => state.themeData.maintheme);

  return (
    <Dialog
      fullScreen
      open={props?.open}
      onClose={() => props?.setOpen(false)}
      TransitionComponent={Transition}
      sx={{
        backgroundColor: "#f5f5f5",
        "& .MuiPaper-root": {
          backgroundColor: "#f5f5f5",
        },
      }}
    >
      <AppBar
        className={classes.appBar}
        sx={{
          backgroundColor: "#1e6a99 !important",
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => {
              props?.setOpen(false);
              props?.clear();
              props?.setObject(null);
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {!props?.object?.task_id ? "إنشاء" : "تعديل"} مهمة نقل الوحدات
            {props?.object?.task_id ? ": " + props?.object?.task_id : ""}
          </Typography>
          <Button autoFocus color="inherit" onClick={props?.submitWithAgreed}>
            Save
          </Button>
        </Toolbar>
      </AppBar>
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.innerContainerHeader}>
          <Grid container className={classes.innerContainerHeader}>
            {props?.loading ? (
              <Preloading />
            ) : (
              <>
                <Grid item xs={6.45} className={classes.secondColumn}>
                  <Box
                    sx={{
                      height: "calc(100vh - 80px)",
                      overflow: "scroll",
                    }}
                  >
                    <Box className="col-12 col-sm-12 col-md-12">
                      <Typography
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          padding: "20px",
                        }}
                      >
                        تفاصيل المهمة
                      </Typography>
                    </Box>
                    <Box className="col-12 col-sm-12 col-md-12">
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <CustomeSelectField
                              label={"من الزبون"}
                              customWidth="100%"
                              haswidth={true}
                              value={
                                props?.selectedCustomer
                                  ? props?.selectedCustomer
                                  : null
                              }
                              list={props?.customers ? props?.customers : []}
                              customGetOptionLabel={(option) =>
                                option?.name || ""
                              }
                              onSearch={(e) =>
                                e?.target?.value
                                  ? props?.handleCustomerSearch(
                                      e?.target?.value
                                    )
                                  : null
                              }
                              error={false}
                              message={[]}
                              multiple={false}
                              readOnly={false}
                              focused={true}
                              onChange={(e, newValue) => {
                                if (newValue) {
                                  props?.setSelectedCustomer(newValue);
                                  props?.setSelectedCustomerID(
                                    newValue.customer_id
                                  );
                                }
                              }}
                              onClearClick={() => {
                                if (props?.checkCustomerHasUnits())
                                  return toast.warning(
                                    "There are some units associated to the selected customer, make sure to remove them first"
                                  );
                                props?.setSelectedCustomer(null);
                                props?.setSelectedCustomerID(null);
                              }}
                            />
                            <Box sx={{ marginTop: "10px" }}></Box>
                            <CustomeSelectField
                              label={"الى الزبون"}
                              customWidth="100%"
                              haswidth={true}
                              value={
                                props?.toSelectedCustomer
                                  ? props?.toSelectedCustomer
                                  : null
                              }
                              list={props?.customers ? props?.customers : []}
                              customGetOptionLabel={(option) =>
                                option?.name || ""
                              }
                              onSearch={(e) =>
                                e?.target?.value
                                  ? props?.handleCustomerSearch(
                                      e?.target?.value
                                    )
                                  : null
                              }
                              error={false}
                              message={[]}
                              multiple={false}
                              readOnly={false}
                              focused={true}
                              onChange={(e, newValue) => {
                                if (newValue) {
                                  props?.setToSelectedCustomer(newValue);
                                  props?.setToSelectedCustomerID(
                                    newValue.customer_id
                                  );
                                }
                              }}
                              onClearClick={() => {
                                props?.setToSelectedCustomer(null);
                                props?.setToSelectedCustomerID(null);
                              }}
                            />
                            <Box sx={{ marginTop: "10px" }}></Box>
                            <CustomeSelectField
                              label={"المهمة معينة الى"}
                              haswidth={true}
                              customWidth="100%"
                              value={
                                props?.selectedAssigners
                                  ? props?.selectedAssigners
                                  : []
                              }
                              list={props?.users ? props?.users : []}
                              customGetOptionLabel={(option) =>
                                option?.name || ""
                              }
                              error={false}
                              message={[]}
                              multiple={true}
                              readOnly={false}
                              focused={true}
                              onChange={(e, newValue) => {
                                props?.setSelectedAssigners(newValue);
                              }}
                              onClearClick={() => {
                                props?.setSelectedAssigners(null);
                              }}
                            />
                            <Box sx={{ marginTop: "10px" }}></Box>
                            <CustomeSelectField
                              label={"المشرف على المهمة"}
                              haswidth={true}
                              customWidth="100%"
                              value={props?.selectedUser}
                              list={props?.users ? props?.users : []}
                              customGetOptionLabel={(option) =>
                                option?.name || ""
                              }
                              error={false}
                              message={[]}
                              multiple={false}
                              readOnly={false}
                              focused={true}
                              onChange={(e, newValue) => {
                                props?.setSelectedUser(newValue);
                              }}
                              onClearClick={() => {
                                props?.setSelectedUser(null);
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                          >
                            {/* <CustomTextField
                              label={"العنوان"}
                              haswidth={true}
                              value={props?.taskTitle}
                              error={false}
                              customWidth="100%"
                              hasMultipleLine={true}
                              message={""}
                              readOnly={false}
                              onChange={(e) => {
                                props?.setTaskTitle(e.target.value);
                              }}
                              onClearClick={() => {
                                props?.setTaskTitle("");
                              }}
                            />
                            <Box sx={{ marginTop: "10px" }}></Box> */}
                            <CustomTextField
                              label={"الوصف"}
                              haswidth={true}
                              customWidth="100%"
                              customHeight={"187px"}
                              value={props?.description}
                              error={false}
                              hasMultipleLine={true}
                              rows={4}
                              message={""}
                              readOnly={false}
                              onChange={(e) => {
                                props?.setDescription(e.target.value);
                              }}
                              onClearClick={() => {
                                props?.setDescription("");
                              }}
                            />
                            <Box
                              sx={{
                                margin: "10px 0 0px 0",
                                marginLeft: "10px",
                                width: "95%",
                                height: "55px",
                                backgroundColor: "#fff",
                                boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                                paddingLeft: "10px",
                                display: "flex",
                                alignItems: "center",
                                borderLeft: "5px solid #1e6a99",
                                cursor: "pointer",
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={props?.allAgreed}
                                    onChange={(e) => {
                                      props?.setAllAgreed(e?.target?.checked);
                                    }}
                                  />
                                }
                                sx={{
                                  width: "100%",
                                }}
                                label="تم إستحصال موافقة الطرفين؟"
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid sx={{ height: "70%", width: "2px" }} />
                <Grid item xs={5.5} className={classes.firstColumn}>
                  <Box
                    sx={{
                      height: "calc(100vh - 80px)",
                      overflow: "scroll",
                    }}
                  >
                    <Box className="col-12 col-sm-12 col-md-12">
                      <Typography
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          padding: "20px",
                        }}
                      >
                        الوحدات المنقولة
                      </Typography>
                    </Box>
                    <Box className="col-12 col-sm-12 col-md-12">
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                          }}
                        >
                          <CustomTextField
                            label={"رقم الوحدة"}
                            haswidth={true}
                            customWidth="100%"
                            value={props?.vehicleNumber}
                            error={false}
                            hasMultipleLine={true}
                            message={""}
                            readOnly={false}
                            onChange={(e) => {
                              props?.setVehicleNumber(e.target.value);
                            }}
                            onClearClick={() => {
                              props?.setVehicleNumber("");
                            }}
                          />
                          <Button
                            variant="contained"
                            className="iconeFilterSearch"
                            sx={{
                              borderRadius: 1,
                              width: "90px !important",
                              minWidth: "80px !important",
                              maxWidth: "80px !important",
                              height: "55px",
                              fontFamily: "Cairo-Bold",
                              padding: "20px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 0.3,
                            }}
                            onClick={props?.addDetails}
                          >
                            <Typography sx={{ fontSize: "13px", mt: "2.5px" }}>
                              ADD
                            </Typography>
                            <AddIcon />
                          </Button>
                        </Box>
                        <Box
                          sx={{
                            width: "95%",
                          }}
                        >
                          <VehiclesList
                            list={props?.selectedVehicles}
                            deleteVehicle={props?.deleteVehicle}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

const AddForm = (props) => {
  var headers = {
    jwt: cookies.get("token"),
  };

  const [taskTitle, setTaskTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState(
    props.time === "1970-01-01T00:00:00.000Z" ? "" : new Date(props?.time)
  );
  const [monitor, setMonitor] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedCustomerID, setSelectedCustomerID] = useState(null);
  const [toSelectedCustomer, setToSelectedCustomer] = useState(null);
  const [toSelectedCustomerID, setToSelectedCustomerID] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedAssigners, setSelectedAssigners] = useState(null);
  const dispatch = useDispatch();
  const [financeDate, setFianaceDate] = useState(null);
  const [detailsDate, setDetailsDate] = useState(null);
  const [selectedFinanceWorkType, setSelectedFinanceWorkType] = useState(null);
  const [selectedFinanceWorkTypeID, setSelectedFinanceWorkTypeID] = useState(
    null
  );
  const [selectedDeviceStatus, setSelectedDeviceStatus] = useState(null);
  const [selectedDeviceStatusID, setSelectedDeviceStatusID] = useState(null);

  const [selectedTechnicianID, setSelectedTechnicianID] = useState(null);
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const [amount, setAmount] = useState(null);

  const [taskDetails, setTaskDetails] = useState([]);
  const [taskFinances, setTaskFinances] = useState([]);

  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [note, setNote] = useState(null);
  const [note1, setNote1] = useState(null);
  const [sn, setSn] = useState(null);
  const [qty, setQty] = useState(0);
  const [allAgreed, setAllAgreed] = useState(false);

  const [type, setType] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [financeWorkTypes, setFinanceWorkTypes] = useState([]);
  const [deviceStatuses, setDeviceStatuses] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [customersUnits, setCustomersUnits] = useState([]);
  const [searchKeys, setSearchKeys] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [loadingVehiclesList, setLoadingVehiclesList] = useState(false);
  const [allTaskUnits, setAllTaskUnits] = useState([]);

  const addDetails = () => {
    if (
      selectedCustomer?.erp_server_type
        ? JSON.parse(selectedCustomer?.erp_server_type) === 1
        : null
    ) {
      var items = [];
      var wantedUnits = [];
      var notFound = [];
      var searchKey = "";
      vehicleNumber?.split(/\n/)?.forEach((v) => {
        if (v.trim()?.length) {
          items.push(v.trim());
        }
      });
      setSearchKeys(items);
      if (customersUnits.some((cu) => items[0] === cu?.name)) {
        searchKey = "name";
        if (items?.length && customersUnits?.length) {
          items.map((item) => {
            const foundUnit = customersUnits.find(
              (unit) =>
                item?.length &&
                unit?.name?.includes(item) &&
                !allTaskUnits?.some((atu) => atu?.id === unit?.id)
            );
            if (foundUnit) {
              wantedUnits.push(foundUnit);
              setAllTaskUnits([...allTaskUnits, foundUnit]);
            } else {
              notFound.push(item);
            }
          });
        }
      } else if (customersUnits.some((cu) => items[0] === cu?.imei)) {
        searchKey = "imei";
        if (items?.length && customersUnits?.length) {
          items.map((item) => {
            const foundUnit = customersUnits.find(
              (unit) => unit?.imei === item
            );
            if (foundUnit) {
              wantedUnits.push(foundUnit);
            } else {
              notFound.push(item);
            }
          });
        }
      } else {
        toast.warning(
          'لم يتم العثور على الوحدات التالية "' + items.join(", ") + '"'
        );
      }
      if (wantedUnits?.length) {
        if (wantedUnits?.length && selectedVehicles?.length) {
          wantedUnits?.map((veh1) => {
            if (!selectedVehicles?.some((veh2) => veh1?.imei === veh2.imei)) {
              setSelectedVehicles([...selectedVehicles, veh1]);
            } else {
              toast.warning("الوحدة موجودة بالفعل: " + veh1?.name);
            }
          });
          setVehicleNumber("");
        } else {
          setSelectedVehicles([...selectedVehicles, ...wantedUnits]);
          setVehicleNumber("");
        }
      }
      if (notFound?.length) {
        toast.warning(
          'لم يتم العثور على الوحدات التالية "' + notFound.join(", ") + '"'
        );
      }
    }
  };

  const loadDataOfCustomers = async (searchParams) => {
    let params = 'searchOperation="contains"&userData={}&';
    try {
      let data = null;
      if (searchParams && searchParams?.length > 0) {
        params +=
          'searchExpr="' +
          searchParams[0] +
          '"&searchValue="' +
          searchParams[1] +
          '"';
      }
      params += "&is_add_or_update=1";

      data = await axios({
        url: host + `customers/page?${params}`,
        method: "get",
        headers: headers,
      }).then((data) => {
        setCustomers(data?.data?.data);
      });
    } catch (err) {
      console.log(err?.message);
    }
  };

  const addFinance = async () => {
    if (!selectedCustomer) return toast.warn("Please select a customer first.");
    if (!selectedTechnician) return toast.warn("Please select a technician.");
    if (amount === null) return toast.warn("Please enter the amount.");
    if (!note1) return toast.warn("Please add a note.");
    if (!financeDate) return toast.warn("Please select a date.");
    const lastID =
      taskFinances?.length > 0 ? taskFinances[taskFinances?.length - 1].id : 0;
    const newID = lastID + 1;
    const newFinance = {
      id: newID,
      technician: selectedTechnician,
      amount: amount,
      note: note1,
      date: helpers.formatDate(financeDate),
    };
    setTaskFinances((prevFinances) => [...prevFinances, newFinance]);
    setSelectedTechnician(null);
    setAmount("");
    setNote1("");
  };

  const handleChangeDetails = (id, key, value) => {
    setTaskDetails((prevDetails) => {
      const index = prevDetails.findIndex((detail) => detail.id === id);
      if (index === -1) return prevDetails;
      const updatedDetails = [...prevDetails];
      updatedDetails[index] = {
        ...updatedDetails[index],
        [key]: value,
      };
      return updatedDetails;
    });
  };

  const deleteVehicle = (idToDelete) => {
    setSelectedVehicles((prevState) => {
      const updatedVehicles = prevState.filter((veh) => veh.id !== idToDelete);
      return updatedVehicles;
    });
  };

  const deleteFinance = (idToDelete) => {
    setTaskFinances((prevState) => {
      return prevState.filter((finance) => finance.id !== idToDelete);
    });
  };

  useEffect(() => {
    if (props?.Allcustomer?.length > 0) {
      let arr = [];
      props?.Allcustomer?.length > 0 &&
        props?.Allcustomer?.map((itm) => {
          arr.push({
            ...itm,
            id: itm?.value,
          });
        });
      setCustomers(arr);
    }
  }, [props?.Allcustomer]);

  useEffect(() => {
    if (props?.editTaskData) {
      setSelectedCustomer(props.customer);
    }
  }, [props.customer]);

  useEffect(() => {
    if (props?.editTaskData) {
      setCustomers(props.customers);
    }
  }, [props.customers]);

  useEffect(() => {
    if (props?.editTaskData) {
      setSelectedUser(props?.monitor);
      setMonitor(props?.monitor?.id);
    }
  }, [props.monitor]);

  useEffect(() => {
    if (props?.editTaskData?.assigners?.length) {
      setSelectedAssigners(
        props?.editTaskData?.assigners?.map((user) => ({
          ...user,
          id: user?.user_id,
        }))
      );
    }
  }, [props?.editTaskData?.assigners]);

  useEffect(() => {
    if (props?.editTaskData) {
      setTaskTitle(props?.title);
    }
  }, [props?.title]);

  useEffect(() => {
    if (props?.editTaskData) {
      setDescription(props?.desc);
    }
  }, [props.desc]);

  useEffect(() => {
    if (props?.editTaskData) {
      setAllAgreed(props?.editTaskData?.all_agreed ? true : false);
    }
  }, [props.editTaskData]);

  useEffect(() => {
    if (props?.editTaskData) {
      setSelectedCustomer(props?.editTaskData?.customer);
      setSelectedCustomerID(props?.editTaskData?.customer?.id);
    }
  }, [props?.editTaskData?.customer]);

  useEffect(() => {
    if (
      props?.editTaskData &&
      props?.editTaskData?.to_customer_id &&
      props?.editTaskData?.to_customer_name
    ) {
      setToSelectedCustomer({
        customer_id: props?.editTaskData?.to_customer_id,
        name: props?.editTaskData?.to_customer_name,
      });
      setToSelectedCustomerID(props?.editTaskData?.to_customer_id);
    }
  }, [props?.editTaskData?.customer]);

  useEffect(() => {
    if (props?.editTaskData?.technician?.name) {
      setSelectedTechnician(props?.editTaskData?.technician);
      setSelectedTechnicianID(props?.editTaskData?.technician?.id);
    }
  }, [props?.editTaskData?.technician]);

  useEffect(() => {
    if (props?.editTaskData && props?.editTaskData?.task_details) {
      setTaskDetails(props?.editTaskData?.task_details);
    }
  }, [props?.editTaskData?.task_details]);

  useEffect(() => {
    if (props?.editTaskData && props?.editTaskData?.task_units_transfer) {
      setSelectedVehicles(props?.editTaskData?.task_units_transfer);
    }
  }, [props?.editTaskData?.task_units_transfer]);

  const assign_user = (id) => {
    var headers = {
      jwt: cookies.get("token"),
    };
    axios({
      url: host + `tasks/assign/${id}`,
      method: "POST",
      headers: headers,
      data: {
        users_id: selectedAssigners?.map((itm) => itm?.id),
      },
    })
      .then((res) => {
        if (res.data.status === true) {
          // toast.success('task created successfully')
          if (monitor !== null) {
            axios({
              url: host + `tasks/assign/monitor/${id}`,
              method: "PUT",
              headers: headers,
              data: {
                monitor_user_id: selectedUser?.id || 9,
              },
            }).then((res) => {
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
            });
          } else {
            // props?.setAddForm(false);
            dispatch(setGlobalLoading(false));
          }
        } else if (res.data.status === false) {
          toast.error(res.data.data.message.text);
          dispatch(setGlobalLoading(false));
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        dispatch(setGlobalLoading(false));
      });
  };

  const submit = async () => {
    var headers = {
      jwt: cookies.get("token"),
    };

    if (props?.createMode) {
      // if (description?.length < 5) {
      //   return toast.error("description must be more than 5 char");
      // }
      if (!selectedCustomerID) {
        return toast.error("إختر زبون رجائاً");
      }
      if (!toSelectedCustomerID) {
        return toast.error("اختر الزبون المنقولة الوحدات اليه رجائاً");
      }
      if (selectedAssigners?.length < 1) {
        return toast.error("حدد مستخدمًا واحدًا على الأقل معنية المهمة له");
      }
      if (selectedUser === null) {
        return toast.error("قم باختيار مشرف المهمة رجائاً");
      }
      dispatch(setGlobalLoading(true));
      let create_path = `Back-${host + `tasks/task`} , Front:${window.location
        .origin + window.location.pathname}`;
      let res = await axios({
        url: host + `tasks/task`,
        method: "POST",
        headers: headers,
        data: {
          task_name: taskTitle ? taskTitle?.replace(/'/g, "") : "",
          description: description ? description.replace(/['"]/g, "") : "",
          dead_time: correctedDeadTime,
          main_task_id: "0",
          task_type_id: 18,
          contacted_num: null,
          num_of_units: null,
          create_path: create_path,
          customer_id: selectedCustomerID,
          to_customer_id: toSelectedCustomerID,
          technician_id: selectedTechnicianID,
          allAgreed: allAgreed ? 1 : 0,
        },
      });
      if (res.data.status === true) {
        if (selectedAssigners?.length > 0) {
          assign_user(res.data.data.data.task_id);
        } else {
          if (selectedUser !== null) {
            axios({
              url: host + `tasks/assign/monitor/${res.data.data.data.task_id}`,
              method: "PUT",
              headers: headers,
              data: {
                monitor_user_id: selectedUser?.id || 9,
              },
            }).then((res) => {
              toast.success("تم انشاء المهمة بنجاح");
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
            });
          } else {
            toast.success("تم انشاء المهمة بنجاح");
            props?.setAddForm(false);
            dispatch(setGlobalLoading(false));
          }
        }
        if (selectedVehicles?.length && res.data.data.data.task_id) {
          axios({
            url: host + `tasks/task_vehicles/${res.data.data.data.task_id}`,
            method: "POST",
            headers: headers,
            data: {
              vehicles: selectedVehicles,
            },
          }).then((res) => {
            props?.setAddForm(false);
            dispatch(setGlobalLoading(false));
          });
        }
        clear();
      } else if (res.data.status === false) {
        toast.error(res.data.data.message.text);
        dispatch(setGlobalLoading(false));
      }
    } else {
      if (startDate !== "") {
        var milliseconds = new Date(startDate)?.getTime() + 3 * 60 * 60 * 1000; //add three hours
        var correctedDeadTime = new Date(milliseconds);
      }
      if (!selectedCustomerID) {
        return toast.error("اختر زبون رجائاً");
      }
      if (!toSelectedCustomerID) {
        return toast.error("اختر الزبون المنقولة الوحدات اليه رجائاً");
      }
      dispatch(setGlobalLoading(true));
      axios({
        url: host + `tasks/task/${props.id}`,
        method: "PUT",
        headers: headers,
        data: {
          task_title: taskTitle ? taskTitle?.replace(/'/g, "") : "",
          description: description ? description.replace(/['"]/g, "") : "",
          num_of_units: null,
          contacted_num: null,
          contacted_person: null,
          dead_time: correctedDeadTime,
          task_type_id: 18,
          customer_id: selectedCustomerID,
          to_customer_id: toSelectedCustomerID,
          technician_id: selectedTechnicianID,
          allAgreed: allAgreed ? 1 : 0,
        },
      })
        .then((res) => {
          if (res.data.status === true) {
            if (selectedAssigners?.length > 0) {
              assign_user(props.id);
            } else {
              if (selectedUser !== null) {
                axios({
                  url: host + `tasks/assign/monitor/${props.id}`,
                  method: "PUT",
                  headers: headers,
                  data: {
                    monitor_user_id: selectedUser?.id || 9,
                  },
                }).then((res) => {
                  props?.setAddForm(false);
                  dispatch(setGlobalLoading(false));
                });
              } else {
                props?.setAddForm(false);
                dispatch(setGlobalLoading(false));
              }
            }
            axios({
              url: host + `tasks/units_transfer/${props.id}`,
              method: "PUT",
              headers: headers,
              data: {
                vehicles: selectedVehicles,
              },
            }).then((res) => {
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
            });

            axios({
              url: host + `tasks/assign/monitor/${props.id}`,
              method: "PUT",
              headers: headers,
              data: {
                monitor_user_id: selectedUser?.id,
              },
            }).then((res) => {
              clear();
              props?.setAddForm(false);
              dispatch(setGlobalLoading(false));
              toast.success("تم تحديث مهمة نقل الوحدات بنجاح");
            });

            clear();
          } else if (res.data.status === false) {
            toast.error(res.data.data.message.text);
            dispatch(setGlobalLoading(false));
            props?.setAddForm(false);
          }
        })
        .catch((err) => {
          toast.error("Network Error");
          dispatch(setGlobalLoading(false));
        });
    }
  };

  const submitWithAgreed = () => {
    if(allAgreed) submit();
    else {
      swal({
        title: "هل أنت متأكد؟",
        text: "هل تريد انشاء مهمة نقل وحدات بدون استحصال موافقة الطرفين؟",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (!willDelete) return;
        submit();
      })
    }
  }

  useEffect(() => {
    if (props?.addForm) {
      setDescription(props?.desc);
      setStartDate(
        props?.createMode
          ? null
          : props?.time === "1970-01-01T00:00:00.000Z"
          ? ""
          : new Date(props?.time)
      );
    }
  }, [props?.addForm]);

  useEffect(() => {
    loadDataOfCustomers();
  }, []);

  const handleCustomerSearch = debounce((value) => {
    let searchParams = ["customer_name", value];
    loadDataOfCustomers(searchParams);
  }, 500);

  const getVehicles = async () => {
    if (
      selectedCustomer &&
      selectedCustomer?.erp_server_id &&
      (selectedCustomer?.erp_server_type
        ? JSON.parse(selectedCustomer?.erp_server_type) === 1
        : null) &&
      typeof JSON.parse(selectedCustomer?.erp_wailon_acc_code) === "number"
    ) {
      try {
        dispatch(setGlobalLoading(true));
        await axios({
          url: host + "customers/get_customers_units",
          method: "GET",
          headers: headers,
          params: {
            erp_server_id: selectedCustomer?.erp_server_id
              ? selectedCustomer?.erp_server_id
              : props?.editTaskData?.customer?.erp_server_id,
            erp_wailon_acc_code: selectedCustomer?.erp_wailon_acc_code
              ? selectedCustomer?.erp_wailon_acc_code
              : props?.editTaskData?.customer?.erp_wailon_acc_code,
          },
        })
          .then((res) => {
            dispatch(setGlobalLoading(false));
            if (!res.data.status) {
              toast.error("Network Error!");
              setCustomersUnits([]);
            } else {
              if (res?.data?.data?.length) {
                setCustomersUnits(res?.data?.data);
              } else {
                setCustomersUnits([]);
                if (selectedFinanceWorkType?.id === 1) {
                  toast.info(
                    "لا يوجد وحدات مرتبطة بهذا الزبون في الوقت الحالي."
                  );
                }
              }
            }
          })
          .catch((e) => {
            dispatch(setGlobalLoading(false));
            console.log("Error", e);
          });
      } catch (error) {
        console.log("Error", error);
      }
    } else {
      setCustomersUnits([]);
      if (selectedFinanceWorkType?.id === 1) {
        toast.info("Customer Doesn't have a wialon account ID.");
      }
    }
  };

  useEffect(() => {
    try {
      (async () => {
        if (props?.editTaskData || taskDetails?.length) {
          const details = taskDetails;
          let summeryResult = [];
          let summeryObj = [
            {
              device: "",
              finance_work_type_id: 1,
              finance_work_type_name: "نصب",
              device_status_name: "",
              numberOfDevices: 0,
            },
            {
              device: "",
              finance_work_type_id: 2,
              finance_work_type_name: "اشتراك",
              device_status_name: "",
              numberOfDevices: 0,
            },
            {
              device: "",
              finance_work_type_id: 3,
              finance_work_type_name: "عبث",
              device_status_name: "",
              numberOfDevices: 0,
            },
            {
              device: "",
              finance_work_type_id: 4,
              finance_work_type_name: "وينك تاك",
              device_status_name: "",
              numberOfDevices: 0,
            },
            {
              device: "",
              finance_work_type_id: 5,
              finance_work_type_name: "خدمات مختلفة",
              device_status_name: "",
              numberOfDevices: 0,
            },
          ];

          if (details?.length) {
            details?.map((td) => {
              const sotd = summeryObj.find(
                (so) => so.finance_work_type_id === td?.selectedWorkType?.id
              );
              if (
                sotd.finance_work_type_id === 1 ||
                sotd.finance_work_type_id === 2 ||
                sotd.finance_work_type_id === 4
              ) {
                sotd.device = td?.vehicles[0].device;
                sotd.device_status_name = td?.device_status_name;
                sotd.numberOfDevices = td?.vehicles?.length;
              } else {
                sotd.numberOfDevices = td?.qty;
              }
              summeryResult.push(sotd);
            });
          }
          setVehiclesList(summeryResult);
          setLoadingVehiclesList(false);
        }
        if (!taskDetails?.length) {
          setVehiclesList([]);
        }
      })();
    } catch (error) {
      console.log("Error: ", error);
      setLoadingVehiclesList(false);
      toast.error("لم يتم استرداد وحدات الزبون من wialon, أبلغ مسؤول النظام");
    }
  }, [taskDetails, props?.editTaskData]);

  const clear = () => {
    setSelectedVehicles([]);
    setSelectedCustomer(null);
    setSelectedCustomerID(null);
    setSelectedCustomer(null);
    setSelectedCustomerID(null);
    setSelectedAssigners(null);
    setSelectedUser(null);
    setDescription(null);
    setTaskFinances([]);
    setTaskDetails([]);
    setAllTaskUnits([]);
    setSelectedTechnician(null);
    setSelectedTechnicianID(null);
    setAmount(null);
    setNote(null);
    setQty(null);
    setFianaceDate(null);
    setSelectedFinanceWorkType(null);
    setSelectedFinanceWorkTypeID(null);
    setVehicleNumber(null);
    setSn(null);
    setSelectedDeviceStatus(null);
    setSelectedDeviceStatusID(null);
    setDetailsDate(null);
    props?.setObject(null);
  };

  useEffect(() => {
    getVehicles();
  }, [selectedCustomer]);

  useEffect(() => {
    dispatch(setGlobalLoading(true));
    var headers = {
      jwt: cookies.get("token"),
    };
    axios({
      url: host + `task_types`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        if (res?.data?.status === false) {
          cookies.remove("token");
          window.location.href = "/";
        } else {
          let arr = [];
          let userarr = [];
          let newtype = [];
          res?.data?.data &&
            res?.data?.data?.length &&
            res?.data?.data?.map((item) => {
              if (
                item?.task_type_id == 2 ||
                item?.task_type_id == 4 ||
                item?.task_type_id == 18 ||
                item?.task_type_id == 7 ||
                item?.task_type_id == 17 ||
                item?.task_type_id == 9 ||
                item?.task_type_id == 12
              ) {
                //Removing واجبات التركيب والصيانة from select task type
              } else {
                let obj = {
                  label: item?.name,
                  value: item?.task_type_id,
                };
                let obj1 = {
                  label: item?.name,
                  value: item?.name,
                };
                arr.push(obj);
              }
            });
          setType(arr);
        }
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
      });
    axios({
      url: host + `tasks/statuses`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        let arr = [];
        for (let index = 0; index < res?.data?.data?.length; index++) {
          let obj = {
            label: res?.data?.data[index]?.status_name,
            value: res?.data?.data[index]?.status_id,
          };
          arr.push(obj);
        }
        setStatuses(arr);
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
      });

    axios({
      url: host + `users/userslist`,
      method: "GET",
      headers: headers,
      params: {
        enabled: 1,
      },
    })
      .then((res) => {
        let arr = [];
        let idarr = [];

        for (let index = 0; index < res?.data?.data?.length; index++) {
          let obj = {
            name: res?.data?.data[index]?.name,
            id: res?.data?.data[index]?.user_id,
          };

          arr.push(obj);
          idarr.push(res?.data?.data[index]?.user_id);
        }
        setUsers(arr);
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
      });
    axios({
      url: host + `users/userslist`,
      method: "GET",
      headers: headers,
      params: {
        department_id: 10,
        enabled: 1,
      },
    })
      .then((res) => {
        setTechnicians(res?.data?.data);
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
      });
    axios({
      url: host + `car_inspection/cars/list`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        setVehicles(res?.data?.data?.data);
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
      });
    axios({
      url: host + `finance_types`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        setFinanceWorkTypes(res.data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios({
      url: host + `device_statuses`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        setDeviceStatuses(res.data.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    dispatch(setGlobalLoading(false));
  }, [props.addForm]);

  const checkCustomerHasUnits = () => {
    if (!selectedVehicles?.length) return true;
    else return false;
  };

  return (
    <div>
      <RenderContent
        open={props.addForm}
        setOpen={props.setAddForm}
        onRefreshGeo={props.onRefreshGeo}
        createMode={props?.createMode}
        selectedVehicles={selectedVehicles}
        setSelectedVehicles={setSelectedVehicles}
        taskTitle={taskTitle}
        setTaskTitle={setTaskTitle}
        description={description}
        setDescription={setDescription}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        customers={customers}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        selectedCustomerID={selectedCustomerID}
        setSelectedCustomerID={setSelectedCustomerID}
        handleCustomerSearch={handleCustomerSearch}
        selectedAssigners={selectedAssigners}
        setSelectedAssigners={setSelectedAssigners}
        selectedTechnician={selectedTechnician}
        setSelectedTechnician={setSelectedTechnician}
        selectedTechnicianID={selectedTechnicianID}
        setSelectedTechnicianID={setSelectedTechnicianID}
        selectedFinanceWorkType={selectedFinanceWorkType}
        setSelectedFinanceWorkType={setSelectedFinanceWorkType}
        selectedFinanceWorkTypeID={selectedFinanceWorkTypeID}
        setSelectedFinanceWorkTypeID={setSelectedFinanceWorkTypeID}
        selectedDeviceStatus={selectedDeviceStatus}
        setSelectedDeviceStatus={setSelectedDeviceStatus}
        selectedDeviceStatusID={selectedDeviceStatusID}
        setSelectedDeviceStatusID={setSelectedDeviceStatusID}
        taskDetails={taskDetails}
        setTaskDetails={setTaskDetails}
        handleChangeDetails={handleChangeDetails}
        addDetails={addDetails}
        deleteVehicle={deleteVehicle}
        vehicleNumber={vehicleNumber}
        setVehicleNumber={setVehicleNumber}
        sn={sn}
        setSn={setSn}
        note={note}
        setNote={setNote}
        qty={qty}
        setQty={setQty}
        note1={note1}
        setNote1={setNote1}
        amount={amount}
        setAmount={setAmount}
        addFinance={addFinance}
        taskFinances={taskFinances}
        deleteFinance={deleteFinance}
        financeDate={financeDate}
        setFianaceDate={setFianaceDate}
        detailsDate={detailsDate}
        setDetailsDate={setDetailsDate}
        customersUnits={customersUnits}
        allstatus={statuses}
        type={type}
        users={users}
        deviceStatuses={deviceStatuses}
        financeWorkTypes={financeWorkTypes}
        technicians={technicians}
        vehicles={vehicles}
        submitWithAgreed={submitWithAgreed}
        setObject={props?.setObject}
        object={props?.object}
        clear={clear}
        vehiclesList={vehiclesList}
        loadingVehiclesList={loadingVehiclesList}
        toSelectedCustomer={toSelectedCustomer}
        setToSelectedCustomer={setToSelectedCustomer}
        toSelectedCustomerID={toSelectedCustomerID}
        setToSelectedCustomerID={setToSelectedCustomerID}
        allAgreed={allAgreed}
        setAllAgreed={setAllAgreed}
        checkCustomerHasUnits={checkCustomerHasUnits}
      />
    </div>
  );
};

export default AddForm;
